"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registrationFields = void 0;
var TimeUtil_1 = require("@pbl/pbl-react-core/lib/utils/TimeUtil");
var react_text_mask_1 = require("react-text-mask");
var yup = __importStar(require("yup"));
var validation_1 = __importStar(require("./validation"));
var firstNameField = {
    type: 'string',
    key: 'firstName',
    label: 'First Name',
    page: 0,
    isRequired: true,
    maxLength: 30,
    get fieldValue() {
        return this.value;
    },
    validationSchema: yup
        .string()
        .required()
        .max(30)
        .matches(/^[a-z ,.'-]+$/i)
};
var lastNameField = {
    type: 'string',
    key: 'lastName',
    label: 'Last Name',
    maxLength: 30,
    page: 0,
    isRequired: true,
    get fieldValue() {
        return this.value;
    },
    validationSchema: yup
        .string()
        .required()
        .max(30)
        .matches(/^[a-z ,.'-]+$/i)
};
var dateOfBirthField = {
    type: 'dateOfBirth',
    key: 'dateOfBirth',
    label: 'Date of Birth',
    page: 0,
    isRequired: true,
    minValue: validation_1.default.minDateOfBirth,
    maxValue: validation_1.default.maxDateOfBirth,
    get fieldValue() {
        return !!this.value ? (0, TimeUtil_1.formatDayMonthYear)(this.value) : undefined;
    },
    validationSchema: yup
        .date()
        .required()
        .min(validation_1.default.minDateOfBirth)
        .max(validation_1.default.maxDateOfBirth)
};
var emailField = {
    type: 'email',
    key: 'email',
    label: 'Email',
    maxLength: 100,
    page: 0,
    isRequired: true,
    get fieldValue() {
        return this.value;
    },
    validationSchema: yup.string().required().email().max(100),
    disabledAutofill: true
};
var passwordField = {
    type: 'password',
    key: 'password',
    label: 'Password',
    page: 0,
    isRequired: true,
    showPassword: true,
    secureTextEntry: true,
    maxLength: 20,
    get fieldValue() {
        return this.value;
    },
    validationSchema: yup
        .string()
        .test('password-validator', 'Enter valid password', function (value) { return value !== null && !!validation_1.default.passwordValidatorSchema.validate(value); })
        .required()
        .max(20),
    disabledAutofill: true
};
var phoneField = {
    type: 'phone',
    key: 'phone',
    label: 'Phone Number',
    page: 1,
    isRequired: true,
    get fieldValue() {
        var _a;
        if (((_a = this === null || this === void 0 ? void 0 : this.value) === null || _a === void 0 ? void 0 : _a.toString().length) > 0) {
            return (0, react_text_mask_1.conformToMask)(this.value, validation_1.phoneMask, {}).conformedValue;
        }
        return this.value;
    },
    validationSchema: yup.string().required().matches(validation_1.default.phoneValidationRegex)
};
var sendUpdatesField = {
    type: 'boolean',
    key: 'sendUpdates',
    label: 'Yes, send me updates and offers via email',
    get placeholder() {
        return this.label;
    },
    page: 0,
    isMultiline: true,
    isRequired: false,
    get fieldValue() {
        return this.value !== null ? this.value.toString() : null;
    }
};
exports.registrationFields = [
    firstNameField,
    lastNameField,
    dateOfBirthField,
    emailField,
    passwordField,
    phoneField,
    sendUpdatesField
];
//# sourceMappingURL=registration.js.map